var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"m-avatar",style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })},[(_vm.src)?_c('img',{staticClass:"m-avatar__image",attrs:{"src":_vm.src,"alt":""}}):_vm._t("default",function(){return [_c('m-icon',{staticClass:"m-avatar__icon",attrs:{"icon":"profile"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }